import React, { Component } from "react";
import { connect } from "react-redux";

import Aux1 from "../Aux1/Aux1";
//import '../../styles/css/jquery.mCustomScrollbar.min.css';
//import '../../styles/css/customScroll.css';
import "react-datepicker/dist/react-datepicker.css";
//import '../../styles/css/tooltip.css';
import '../../styles/css/fonts.css';
import "primeicons/primeicons.css";
import "primereact/resources/themes/saga-blue/theme.css";
import "primereact/resources/primereact.css";
import "primeflex/primeflex.css";
import '../../styles/css/bootstrap.min.css';
import '../../styles/css/style.css';
import '../../styles/css/responsive.css';
import Login from '../../components/Launch/Login';
// import Login from '../../containers/Auth/Auth';
// import Landing from '../../components/Landing/Landing';
// import Home from '../../components/Home/Home';
// import TopHeader from '../../components/TopHeader/TopHeader';

const urlArray = [
  "/",
  "/landing",
  "/home",
  "/loader"
]

class Layout extends Component {
  
  render() {
    if (this.props.isAuthenticated){
      return ( 
        <Aux1>
            {this.props.children}
        </Aux1>
      );
    }
    else if((urlArray.find(x => x === this.props.children._owner.pendingProps.location.pathname) === undefined) && (localStorage.token === undefined || localStorage.token ===""))
    {
      localStorage.setItem("templink", this.props.children._owner.pendingProps.location.pathname.replace("#",""));
      return (
        <Aux1>
          <Login></Login>
        </Aux1>
      );
    }
    else {
      return (
          <Aux1>
            {this.props.children}
          </Aux1>
        );
  }
  }
}

const mapStateToProps = state => {
  return {
    isAuthenticated: state.auth.token !== null
  };
};

export default connect(mapStateToProps)(Layout);
